import { useEffect } from 'react';
import { userManager } from './oidc.js';

/** Hidden-iframe target for automatic silent token renewal. */
export function SilentRenewPage() {
  useEffect(() => {
    void userManager?.signinSilentCallback().catch(() => {
      /* surfaced via the next API 401 */
    });
  }, []);
  return null;
}
